import { cardIcon, paypalIcon, defaultCardIcon } from 'assets/svg-icons';
import { FC, memo, useEffect } from 'react';
import Radio from '../radio';
import './styles.scss';

const ChooseCard: FC<{
  editCardInfo: number;
  onChange: (val: number) => void;
  defaultCard?: boolean;
  paypal?: boolean;
  stripe?: boolean;
}> = ({ editCardInfo, onChange, defaultCard, paypal, stripe }) => {
  
  return (
  <div className="d-md-flex radio-buttons-wrapper justify-content-center">
    {stripe && (
      <>
        {defaultCard && (
          <div className="text-center d-flex payment-option">
            <Radio checked={editCardInfo === 1} border onClick={() => editCardInfo !== 1 && onChange(1)} />
            <div className="radio-label default-card" onClick={() => editCardInfo !== 1 && onChange(1)}>
              {defaultCardIcon} Default payment method
            </div>
          </div>
        )}
        <div className="text-center d-flex payment-option">
          <Radio checked={editCardInfo === 2} border onClick={() => editCardInfo !== 2 && onChange(2)} />
          <div className="radio-label card-icon" onClick={() => editCardInfo !== 2 && onChange(2)}>
            {cardIcon}
          </div>
        </div>
      </>
    )}
    {paypal && (
      <div className="text-center d-flex payment-option">
        <Radio checked={editCardInfo === 3} border onClick={() => editCardInfo !== 3 && onChange(3)} />
        <div className="radio-label paypal-icon" onClick={() => editCardInfo !== 3 && onChange(3)}>
          {paypalIcon}
        </div>
      </div>
    )}
  </div>
)}

export default memo(ChooseCard);
